export default __webpack_public_path__ + "static/media/FieldOfTheDeadEntranceMap.967f48d9.jpg";